import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col, Card } from "react-bootstrap";
import { get_articles, get_tags } from "../../redux/actions";
import { multipleArticle } from "../../mockData/Sample";
import SinglePostCard from "../../components/singlePostCard";

export default function MainPage() {
  const dispatch = useDispatch();
  const globalState = useSelector((state) => state);

  // const [articles, setArticles] = useState([]);

  useEffect(() => {
    dispatch(get_articles("get", `${process.env.REACT_APP_URL}/api/articles?limit=5`));
    dispatch(get_tags("get", `${process.env.REACT_APP_URL}/api/tags`));
  }, []);

  function buttonOnclickHandler(item) {
    // if (item.favorited) {
    //   dispatch(unFavoriteArticle(item.slug));
    // } else dispatch(favoriteArticle(item.slug));
  }

  function onReadMoreClick(item) {
    // dispatch(getSingleArticle(item.slug));
    // dispatch(setLoadingTrue());
  }

  function setReadableDate(date) {
    const readableDate = new Date(date);
    return readableDate.toDateString();
  }

  function likeButtonClassHelper(article, type) {
    if (type === "className") {
      if (article.favorited) {
        return "btn border border-success py-0 px-1 like-button";
      } else return "btn btn-success py-0 px-1";
    } else {
      if (article.favorited) {
        return "Liked";
      } else return "Like";
    }
  }

  function setReadableDate(date) {
    const readableDate = new Date(date);
    return readableDate.toDateString();
  }

  return (
    <div className="main-page-div">
      {globalState.posts ? (
        <>
          <Row className="mx-0 main-page-top-row" />
          <Container>
            <Row>
              <Col sm={12} md={8}>
                <Row className="mt-0">
                  <SinglePostCard topPost={true} item={globalState.posts[0]} />
                </Row>
                <Row xs={1} md={2} className="g-4">
                  {globalState.posts.map((item, index) => {
                    if (index !== 0)
                      return <SinglePostCard key={index} item={item} />
                  })}
                </Row>
              </Col>
              <Col sm={12} md={4}>
                <Card border="dark">
                  <Card.Header>Tags</Card.Header>
                  <Card.Body>
                    <div className="d-flex">
                      {globalState.tags ? (
                        globalState.tags.map((item, index) => (
                          <div
                            key={index}
                            className="border border-secondary rounded-pill px-3"
                          >
                            {/* <Card.Text>{item}</Card.Text> */}
                            <Link to={`/tags/post/${item}`}>{item}</Link>
                          </div>
                        ))
                      ) : (
                        <div>Loading</div>
                      )}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </>
      ) : (
        <div>Loading</div>
      )}
    </div>
  );
}
